module.exports = __webpack_public_path__ + "static/media/accident.6bc50260.svg";